import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const metricsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/metrics',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Metrics',
                href: '/agents/:agentId/metrics',
            },
        },
    ],
    children: [
        {
            path: ':metricId',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: {
                        label: 'Metric details',
                        href: '/agents/:agentId/metrics/:metricId',
                    },
                },
            ],
            children: [
                {
                    path: 'schema',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: {
                                label: 'Schema',
                                isCurrentPage: true,
                            },
                        },
                    ],
                },
                {
                    path: 'events',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: {
                                label: 'Events',
                                isCurrentPage: true,
                            },
                        },
                    ],
                },
            ],
        },
    ],
};
